import { useTranslation } from 'react-i18next';

export default function PledgeBanner() {
  const { t } = useTranslation('home');

  return (
    <div className="px-3 mt-5 mb-6">
      <div className="bg-gradient-to-r from-brown-100/80 via-gold-50/60 to-brown-100/80 rounded-2xl">
        <div className="flex items-center justify-between px-5 py-3.5 gap-4">
          {/* 左侧：CJJY 标志（跟顶部 Logo 一样） */}
          <div className="flex-shrink-0 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/3dc270e4-5b61-4676-ac46-8193427c09c6.png"
              alt="CJJY"
              className="h-11 w-auto object-contain flex-shrink-0"
            />
          </div>

          {/* 右侧：标语 */}
          <div className="text-right flex-1">
            <p className="text-brown-800 text-sm font-semibold tracking-wider">
              {t('promiseValues')}
            </p>
            <p className="text-brown-500 text-xs mt-1">
              {t('promiseSubtitle')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}